<template>
  <div class="p-8">
    <form @submit.prevent="add">
      <div class="flex pt-4 border-t">
        <div class="w-1/3">
          <h3 class="font-semibold uppercase text-gray-600 text-xl">
            New Account
          </h3>
          <p class="text-gray-600">Add a new account!</p>
        </div>
        <div class="w-2/3">
          <div class="flex space-x-4 mt-4">
            <label class="block w-1/2">
              <span class="text-gray-700">First Name</span>
              <input
                v-model="firstName"
                class="form-input block w-full"
                placeholder="Abbay"
              />
            </label>
            <label class="block w-1/2">
              <span class="text-gray-700">
                Last Name
              </span>
              <input
                v-model="lastName"
                class="form-input block w-full"
                placeholder="Kassa"
              />
            </label>
            <label class="block w-1/2">
              <div class="text-gray-700">
                Role
              </div>
              <label for="admin" class="mr-3">
                <input
                  type="checkbox"
                  name="admin"
                  :value="1"
                  v-model="roles"
                  id="admin"
                  class="mr-2"
                />
                <span>Admin</span>
              </label>
              <label for="dispatcher" class="mr-3">
                <input
                  type="checkbox"
                  name="dispatcher"
                  :value="2"
                  v-model="roles"
                  id="dispatcher"
                  class="mr-2"
                />
                <span>Dispatcher</span>
              </label>
              <label for="finance">
                <input
                  type="checkbox"
                  name="finance"
                  :value="3"
                  v-model="roles"
                  id="finance"
                  class="mr-2"
                />
                <span>Finance</span>
              </label>
            </label>
          </div>
          <div class="flex space-x-4 mt-4">
            <label class="block w-1/2">
              <span class="text-gray-700">
                Email
              </span>
              <input
                v-model="email"
                class="form-input block w-full"
                type="email"
                placeholder="contact@sheraton.com"
              />
            </label>
            <label class="block w-1/2">
              <span class="text-gray-700">
                Password
              </span>
              <input
                v-model="password"
                class="form-input block w-full"
                type="Password"
                placeholder="contact@sheraton.com"
              />
            </label>
            <label class="block w-1/2 mt-2">
              <span class="text-gray-700">
                Confirm Password
              </span>
              <input
                v-model="confirmPassword"
                class="form-input block w-full"
                type="password"
                placeholder="contact@sheraton.com"
              />
            </label>
          </div>
          <div class="mt-4">
            <button
              :disabled="busy"
              class="w-32 py-2 text-ilift-900 rounded shadow"
              :class="
                busy
                  ? 'bg-ilift-200 cursor-not-allowed'
                  : 'bg-ilift-500 hover:bg-ilift-600'
              "
            >
              Add
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      busy: false,
      firstName: "",
      lastName: "",
      email: "",
      roles: [],
      password: "",
      confirmPassword: ""
    };
  },
  methods: {
    add() {
      if (
        this.firstName != "" &&
        this.lastName != "" &&
        this.email != "" &&
        this.password != "" &&
        this.password == this.confirmPassword &&
        this.roles.length
      ) {
        var data = {
          firstName: this.firstName,
          lastName: this.lastName,
          email: this.email,
          password: this.password,
          roles: this.roles
        };
        console.log(data);
        this.busy = true;
        this.$http
          .post("/accounts", data)
          .then(() => this.$router.push("/accounts"))
          .catch(err => console.log(err))
          .finally(() => (this.busy = false));
      }
    }
  }
};
</script>
